var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCostEstimatorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 509.36 509.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 254.68,
    y1: 510.79,
    x2: 254.68,
    y2: -0.08,
    gradientTransform: "translate(0 510.07) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0780af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d6183"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 509.36,
    height: 509.36,
    rx: 54.11,
    ry: 54.11,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 282.5,
    width: 1.49,
    height: 0.99,
    style: {
      fill: "#0b7ba5"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,98.18c-22.09,0-40,17.91-40,40v233c0,22.09,17.91,40,40,40h158.06c22.09,0,40-17.91,40-40v-233c0-22.09-17.91-40-40-40h-158.06ZM190.76,124.63c-15.83,0-28.65,12.83-28.65,28.65s12.83,28.65,28.65,28.65h127.84c15.83,0,28.65-12.83,28.65-28.65s-12.83-28.65-28.65-28.65h-127.84ZM294.36,292.15c0-14.61,11.84-26.45,26.45-26.45s26.45,11.84,26.45,26.45v66.13c0,14.61-11.84,26.45-26.45,26.45s-26.45-11.84-26.45-26.45v-66.13ZM188.55,199.57c-14.61,0-26.45,11.84-26.45,26.45s11.84,26.45,26.45,26.45,26.45-11.84,26.45-26.45-11.84-26.45-26.45-26.45ZM228.23,226.02c0-14.61,11.84-26.45,26.45-26.45s26.45,11.84,26.45,26.45-11.84,26.45-26.45,26.45-26.45-11.84-26.45-26.45ZM320.81,199.57c-14.61,0-26.45,11.84-26.45,26.45s11.84,26.45,26.45,26.45,26.45-11.84,26.45-26.45-11.84-26.45-26.45-26.45ZM162.1,292.15c0-14.61,11.84-26.45,26.45-26.45s26.45,11.84,26.45,26.45-11.84,26.45-26.45,26.45-26.45-11.84-26.45-26.45ZM254.68,265.7c-14.61,0-26.45,11.84-26.45,26.45s11.84,26.45,26.45,26.45,26.45-11.84,26.45-26.45-11.84-26.45-26.45-26.45ZM162.1,358.28c0-14.61,11.84-26.45,26.45-26.45s26.45,11.84,26.45,26.45-11.84,26.45-26.45,26.45-26.45-11.84-26.45-26.45ZM254.68,331.83c-14.61,0-26.45,11.84-26.45,26.45s11.84,26.45,26.45,26.45,26.45-11.84,26.45-26.45-11.84-26.45-26.45-26.45Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostEstimatorIcon);
export default __webpack_public_path__ + "static/media/cost-estimator-icon.3f36c75f8f9b812faff25f8b6bf7ce62.svg";
export { ForwardRef as ReactComponent };